import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import AuthChallenge from "@/components/Authentication/AuthChallenge";

export const getChallengeRoutes = (allowRedirect, props) => (
  <Switch>
    <Route component={AuthChallenge} path="/auth/challenge" />

    {allowRedirect && <Redirect to={props.auth.authRedirectPath} />}
  </Switch>
);
